import styled from 'styled-components';

interface DogColorBaseProps {
  $color: string;
}

export const DogColorBase = styled.span<DogColorBaseProps>`
  position: relative;
  display: inline-block;

  & img {
    image-rendering: pixelated;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 3px;
    bottom: 4px;
    left: 3px;
    right: 4px;
    border-radius: 50%;
    mix-blend-mode: multiply;
    opacity: 0.9;
    background: ${(props) => props.$color};
  }
`;

export const ItemImg = styled.img`
  height: 42px;
  vertical-align: middle;
`;
